import React from 'react';
import styles from './ActorCell.module.css';
import { actorDisplayName, actorInitials } from './actorName';

const AVATAR_COLORS = ['#1570EF', '#7839EE', '#067647', '#B54708', '#C11574', '#0E7090'];

function actorColor(actor) {
  let h = 0;
  for (let i = 0; i < (actor || '').length; i++) h = (h * 31 + actor.charCodeAt(i)) & 0xffffffff;
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}

function RobotAvatar() {
  return (
    <span className={`${styles.avatar} ${styles.robotAvatar}`} aria-hidden="true">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="8" width="16" height="11" rx="2.5" />
        <path d="M12 8V5M9 4h6M9 13h.01M15 13h.01M9.5 16.5h5" />
      </svg>
    </span>
  );
}

function ActorAvatar({ actor }) {
  if (!actor) return <RobotAvatar />;
  return (
    <span className={styles.avatar} style={{ background: actorColor(actor), color: '#fff' }} aria-hidden="true">
      {actorInitials(actor)}
    </span>
  );
}

export default function ActorCell({ actor, className = '' }) {
  return (
    <span className={`${styles.cell} ${className}`}>
      <ActorAvatar actor={actor} />
      <span className={styles.name} title={actor || 'System'}>
        {actorDisplayName(actor)}
      </span>
    </span>
  );
}
